<template>
    <div class="p-6 bg-gray-100 min-h-screen flex flex-col items-center justify-center">
      <div class="max-w-lg w-full">
        <!-- Si la clave no está autorizada (autorizado === "0") -->
        <div v-if="registro.autorizado === '0'" class="bg-gray-300 p-6 rounded shadow mb-6 text-center">
          <h2 class="text-xl font-bold mb-4">Procesando tu proyecto</h2>
          <div class="bg-white p-4 rounded shadow mb-4">
            <img src="@/assets/logohp.png" alt="Procesando" class="mx-auto mb-4" />
            <p class="text-gray-700">Tu resultado aún no está listo, pero podrás verlo aquí más tarde.</p>
          </div>
          <div>
                <p class="text-gray-800 font-semibold mb-4">
                Comparte tu resultado para revisarlo más tarde o compartirlo con quien gustes.
                </p>
                <!-- Botón para compartir -->
                <button
                @click="compartirEnlace"
                class="bg-blue-500 mx-auto text-white p-4 rounded-full shadow hover:bg-blue-600 flex items-center justify-center">
                <i class="fas fa-share-alt mr-2"></i> Compartir
                </button>
            </div>
        </div>
  
        <!-- Si la clave está autorizada (autorizado === "1") -->
        <div v-else class="bg-white p-6 rounded shadow text-center">
          <h2 class="text-xl font-bold mb-4">Tu Resultado</h2>
          <!-- Renderizar imagen -->
           <div class="py-10">
            <div v-if="registro.tipo === 'imagen'">
                <img :src="registro.imagen_modificada" alt="Imagen Procesada" class="mx-auto mb-4 max-w-full" />
                <span>Imagen creada con Inteligencia Artificial</span>
            </div>
            <!-- Renderizar video -->
            <div v-else-if="registro.tipo === 'video'">
                <video :src="registro.video" controls class="mx-auto mb-4 max-w-full"></video>
            </div>
            </div>
          <div>
            <p class="text-gray-800 font-semibold mb-4">
            Comparte tu resultado para revisarlo más tarde o compartirlo con quien gustes.
            </p>
            <!-- Botón para compartir -->
            <button
            @click="compartirEnlace"
            class="bg-blue-500 mx-auto text-white p-4 rounded-full shadow hover:bg-blue-600 flex items-center justify-center">
            <i class="fas fa-share-alt mr-2"></i> Compartir
            </button>
          </div>
        </div>
        
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  
  export default {
    setup() {
      const route = useRoute();
      const registro = ref({});
      const token = ref(route.params.token);

      const enlaceCompartir = `https://hpinfo.online/check-result/${token.value}`;

      const compartirEnlace = async () => {
        if (navigator.share) {
          try {
            await navigator.share({
              title: 'Mira mi resultado',
              text: '¡Revisa este proyecto que generé!',
              url: enlaceCompartir,
            });
            console.log('Enlace compartido exitosamente');
          } catch (err) {
            console.error('Error al compartir:', err);
          }
        } else {
          // Fallback si no es compatible
          alert(`Copia este enlace para compartir:\n${enlaceCompartir}`);
        }
      };
  
      const obtenerRegistro = async () => {
        try {
          const { data } = await axios.post("/api/claves-finales/obtener-por-clave", {
            clave_final: token.value,
          });
          registro.value = data.data;
        } catch (error) {
          console.error("Error al consultar el registro:", error);
          alert("No se encontró información para este token.");
        }
      };
  
      onMounted(() => {
        obtenerRegistro();
      });
  
      return { registro , compartirEnlace };
    },
  };
  </script>
  
  <style scoped>
  /* Estilos personalizados si es necesario */
  </style>
  